module.exports = __webpack_public_path__ + "static/media/astonished.85490ff7.svg";